import { useTranslation } from 'react-i18next';
import { useSEO, generateWebPageSchema } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import { useEffect } from 'react';

const PrivacyPage = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://evesmart.qa';

  const title = t('privacy.title');
  const description = t('privacy.description');

  useSEO({
    title,
    description,
    keywords: 'سياسة الخصوصية, privacy policy, EVE Smart, إيف سمارت',
    canonical: `${siteUrl}/privacy`,
    schema: generateWebPageSchema(siteUrl, '/privacy', title, description)
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className={`font-tajawal text-4xl md:text-5xl font-bold text-gray-900 mb-8 ${isRTL ? 'text-right' : 'text-left'}`}>
            {t('privacy.title')}
          </h1>

          <div className={`space-y-8 ${isRTL ? 'text-right' : 'text-left'}`}>
            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('privacy.section1.title')}
              </h2>
              <p className="font-tajawal text-base text-gray-700 leading-relaxed">
                {t('privacy.section1.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('privacy.section2.title')}
              </h2>
              <p className="font-tajawal text-base text-gray-700 leading-relaxed mb-4">
                {t('privacy.section2.content')}
              </p>
              <ul className={`list-disc ${isRTL ? 'mr-6' : 'ml-6'} space-y-2`}>
                <li className="font-tajawal text-base text-gray-700">{t('privacy.section2.item1')}</li>
                <li className="font-tajawal text-base text-gray-700">{t('privacy.section2.item2')}</li>
                <li className="font-tajawal text-base text-gray-700">{t('privacy.section2.item3')}</li>
                <li className="font-tajawal text-base text-gray-700">{t('privacy.section2.item4')}</li>
              </ul>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('privacy.section3.title')}
              </h2>
              <p className="font-tajawal text-base text-gray-700 leading-relaxed mb-4">
                {t('privacy.section3.content')}
              </p>
              <ul className={`list-disc ${isRTL ? 'mr-6' : 'ml-6'} space-y-2`}>
                <li className="font-tajawal text-base text-gray-700">{t('privacy.section3.item1')}</li>
                <li className="font-tajawal text-base text-gray-700">{t('privacy.section3.item2')}</li>
                <li className="font-tajawal text-base text-gray-700">{t('privacy.section3.item3')}</li>
                <li className="font-tajawal text-base text-gray-700">{t('privacy.section3.item4')}</li>
              </ul>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('privacy.section4.title')}
              </h2>
              <p className="font-tajawal text-base text-gray-700 leading-relaxed">
                {t('privacy.section4.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('privacy.section5.title')}
              </h2>
              <p className="font-tajawal text-base text-gray-700 leading-relaxed">
                {t('privacy.section5.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('privacy.section6.title')}
              </h2>
              <p className="font-tajawal text-base text-gray-700 leading-relaxed">
                {t('privacy.section6.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('privacy.section7.title')}
              </h2>
              <p className="font-tajawal text-base text-gray-700 leading-relaxed">
                {t('privacy.section7.content')}
              </p>
            </section>

            <div className="bg-white rounded-2xl shadow-sm p-8 mt-8">
              <h2 className="font-almarai text-2xl mb-4">{t('privacy.contact.title')}</h2>
              <p className="font-tajawal text-gray-700 leading-relaxed mb-4">
                {t('privacy.contact.content')}
              </p>
              <p className="font-tajawal text-gray-700">
                <strong>{t('privacy.contact.email')}:</strong>{' '}
                <a href="mailto:evevsmart@gmail.com" className="text-primary hover:underline">
                  evevsmart@gmail.com
                </a>
              </p>
              <p className="font-tajawal text-gray-700">
                <strong>{isRTL ? 'الهاتف' : 'Phone'}:</strong>{' '}
                <a href="tel:+97474010700" className="text-primary hover:underline" dir="ltr">
                  +974 7401 0700
                </a>
              </p>
            </div>

            <p className={`font-tajawal text-sm text-gray-500 pt-8 border-t border-gray-200 ${isRTL ? 'text-right' : 'text-left'}`}>
              {isRTL ? 'آخر تحديث: ' : 'Last Updated: '}{new Date().toLocaleDateString(isRTL ? 'ar-QA' : 'en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </p>
          </div>
        </div>
      </div>

      <footer className="bg-primary py-6">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="font-tajawal text-white text-sm">
            {t('footer.copyright')}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
